// extracted by mini-css-extract-plugin
export default {"wrapper":"text__wrapper__ifr60","title":"text__title__Kyste","body":"text__body__rCFud","img":"text__img__gOs1t","container":"text__container__g0wg0"};